import {
  CustomerBusinessType,
  CustomerCollectedDataStatus,
  CustomerCollectedDataType,
  CustomerCollectedDataTypeExtended,
  CustomerMCLinkInfoType,
  CustomerResubmitInfoType,
  CustomerTaxIdType,
} from './enums'

export const customerBusinessTypeTitles = {
  [CustomerBusinessType.Own]: 'I own vehicles',
  [CustomerBusinessType.Lease]: 'I lease vehicles',
  [CustomerBusinessType.IcsProvide]: 'my ICs provide their own vehicles only',
  [CustomerBusinessType.Other]: 'Other (note)',
}

export const customerBusinessTypeRadioOptions = [
  {
    label: customerBusinessTypeTitles[CustomerBusinessType.Own],
    value: CustomerBusinessType.Own,
  },
  {
    label: customerBusinessTypeTitles[CustomerBusinessType.Lease],
    value: CustomerBusinessType.Lease,
  },
  {
    label: customerBusinessTypeTitles[CustomerBusinessType.IcsProvide],
    value: CustomerBusinessType.IcsProvide,
  },
  {
    label: customerBusinessTypeTitles[CustomerBusinessType.Other],
    value: CustomerBusinessType.Other,
  },
]

export const customerTaxIdTypeTitles = {
  [CustomerTaxIdType.Ein]: 'EIN',
  [CustomerTaxIdType.Itin]: 'ITIN',
}

export const customerTaxIdTypeRadioOptions = [
  {
    label: customerTaxIdTypeTitles[CustomerTaxIdType.Ein],
    value: CustomerTaxIdType.Ein,
  },
  {
    label: customerTaxIdTypeTitles[CustomerTaxIdType.Itin],
    value: CustomerTaxIdType.Itin,
  },
]

export const customerComplianceStepTitles: Record<CustomerCollectedDataTypeExtended, string> = {
  [CustomerCollectedDataType.Insurance]: 'Insurance',
  [CustomerCollectedDataType.BusinessDetails]: 'Business Details',
  [CustomerCollectedDataType.GigsafeContract]: 'Gigsafe contract',
  [CustomerResubmitInfoType.PaymentInfo]: 'Payment Information',
  [CustomerResubmitInfoType.BusinessInfo]: 'Business Information',
  [CustomerMCLinkInfoType.SignContract]: 'Sign the contract',
  [CustomerCollectedDataType.TSA]: 'TSA Security Assessment',
  [CustomerResubmitInfoType.PaymentMethod]: 'Settlement Method',
}

export const customerCollectedDataStatusTitle = {
  [CustomerCollectedDataStatus.Created]: 'Not Started',
  [CustomerCollectedDataStatus.InProgress]: 'In progress',
  [CustomerCollectedDataStatus.WaitingForInternalApproval]: 'Pending',
  [CustomerCollectedDataStatus.Completed]: 'Approved',
  [CustomerCollectedDataStatus.Failed]: 'Failed',
  [CustomerCollectedDataStatus.Expired]: 'Expired',
  [CustomerCollectedDataStatus.Archived]: 'Archived',
}
